// extracted by mini-css-extract-plugin
export default {"wrapper":"FlatAreaFilter_wrapper__0vAO6","label":"FlatAreaFilter_label__QTywv","inputs":"FlatAreaFilter_inputs__6tbgt"};